'use client';

import { useMemo } from 'react';
import { EmblaCarousel } from "../components/embla-carousel";
import { CardNormalItem } from "../services/home";
import useFn from "@/hooks/use-fn";
import { useRouter } from "@/i18n/navigation";
import { menuTabUrl } from "@/const/page-url";
import { useTranslations } from "next-intl";
import { track } from "@/utils/track";
import GameCardWithExposure from "../components/game-card-with-exposure";
import { useCasinoList } from '../services/casino';
import { Spin } from '@/components/ui-feat/spin';
import { Skeleton } from '@/components/ui/skeleton';

export default function Casino() {
  const t = useTranslations('home');
  const router = useRouter();

  const { data: casinoDataRes, isLoading } = useCasinoList.useQueryHook({});

  const casinoList = useMemo(() => {
    if (!casinoDataRes?.content) {
      return [];
    }
    try {
      const parsed = typeof casinoDataRes.content === 'string'
        ? JSON.parse(casinoDataRes.content) as CardNormalItem[]
        : (casinoDataRes.content as CardNormalItem[]);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [casinoDataRes]);

  const handleViewAll = useFn(() => {
    router.push(menuTabUrl.casino);
    track('container_button_click', {
      current_page: 'Home',
      container_name: 'casino',
      button_name: 'View All'
    });
  });

  return (
    <>
      {
        isLoading ? (
          <div className="flex flex-col space-y-2">
            <div className="space-y-1">
              <Skeleton className="h-4 w-1/4" />
            </div>
            <div className="flex gap-2">
              <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
              <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
              <Skeleton className="h-44 w-1/5 rounded-lg" />
            </div>
            <div className="flex gap-2">
              <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
              <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
              <Skeleton className="h-44 w-1/5 rounded-lg" />
            </div>
          </div>
        ) : <>
          <EmblaCarousel
            title={'Casino'}
            rows={2}
            columns={2}
            className="pl-[12px]"
            rightTitle={t('viewAll')}
            showViewAll={casinoList.length > 5}
            onClickViewAll={handleViewAll}
          >
            {casinoList.map((item, index) => (
              <GameCardWithExposure
                key={item?.id || index}
                item={item}
                index={index}
                currentPage="Home"
                currentModule="casino"
                priority={index < 3}
              />
            ))}
          </EmblaCarousel>
        </>
      }
    </>
  );
}